<template>
    <v-page-content>
      <template v-if="!isSubdivision">
        <v-content-info-page></v-content-info-page>
      </template>
      <template v-else>
        <b-card>
          <h4>Страница класса для подразделений отсутствует.</h4>
        </b-card>
      </template>
    </v-page-content>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import _ from 'lodash'
import { types } from '@/config/content/types'

export default {
  name: 'SelectedClass',
  data() {
    return {
      selectedId: null
    }
  },
  async created() {
    this.selectedId = this.$route.params.gpClass
    await this.getData()
  },
  async beforeRouteUpdate(to, from, next) {
    this.selectedId = to.params.gpClass
    await this.getData()
    next()
  },
  computed: {
    ...mapGetters({
      currUser: 'currentUser/getCurrentUser',
      content: 'content/getContent'
    }),
    isSubdivision() {
      return _.isEmpty(this.content)
    }
  },
  methods: {
    ...mapActions({
      fetchSelectedGPClass: 'content/fetchSelectedClass',
      fetchUserClass: 'content/fetchUserClass'
    }),
    ...mapMutations({
      setContentType: 'content/setContentType'
    }),
    async getData() {
      if (this.selectedId === 'current') {
        await this.fetchUserClass(this.currUser.organizationId)
      } else {
        this.fetchSelectedGPClass(this.selectedId).then((data) => {
          if (data) {
            this.$router.push('/page_not_exist')
          } else {
            this.setContentType(types.class)
          }
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
